// extracted by mini-css-extract-plugin
export default {"container":"store-quick-view-features__container___BdSnl","icon":"store-quick-view-features__icon___304Qd"};